import { faBrain } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Card, Space, Typography } from 'antd'
import { useDeleteMemoryMutation } from '../../domain/memory/memoryQueries'
import { MemorySavedPart } from './aiAssistantModel'

type Props = {
  part: MemorySavedPart
}

// Memories are the speaker's own (chat#255), so the card says "for you" and
// never suggests the save applies to the company.
const MemorySavedCard = ({ part }: Props) => {
  const deleteMemory = useDeleteMemoryMutation()

  return (
    <Card size="small" style={{ margin: '8px 0' }}>
      <Space align="start">
        <FontAwesomeIcon icon={faBrain} style={{ marginTop: 4 }} />
        {deleteMemory.isSuccess ? (
          <Typography.Text type="secondary">Removed</Typography.Text>
        ) : (
          <Space direction="vertical" size={4}>
            <Typography.Text>
              <Typography.Text strong>Saved for you:</Typography.Text>{' '}
              <Typography.Text italic>{part.content}</Typography.Text>
            </Typography.Text>
            {deleteMemory.isError && (
              <Typography.Text type="danger">Couldn&apos;t remove it. Try again.</Typography.Text>
            )}
            <Button
              size="small"
              loading={deleteMemory.isLoading}
              onClick={() => deleteMemory.mutate(part.memory_id)}
            >
              Undo
            </Button>
          </Space>
        )}
      </Space>
    </Card>
  )
}

export default MemorySavedCard
